/*
 * Copyright 2025 Intuition Robotics ltd
 */
import React, {useEffect} from "react";
import {css} from 'emotion';
import {UsersModule} from "@modules/UsersModule";

export const Page_Unsubscribe = () => {

    useEffect(() => {
        UsersModule.unsubscribe().catch(console.error);
    })

    return <>
        <div className={css`background-color: #F0F5F8;
          margin: 0;
          padding: 0;
          -webkit-text-size-adjust: 100%;
          -ms-text-size-adjust: 100%;`}>
            <div className={css`width: 90%;
              margin: 0 auto;
              height: 100vh;
              display: flex;
              flex-direction: column;
              justify-content: center;`}>
                <div className={css`padding: 20px;
                  text-align: center;
                  background: white;
                  display: block;`}>
                    <div className={css`margin-bottom: 20px;
                      display: block;`}>
                        <img
                            src="https://dev-cdn.s.elliq.co/resources_v2/care_center/elliq_mail_image_updated.png"
                            alt="Image"
                            className={css`width: 150px;
                              height: 150px;`}/>
                    </div>
                    <div className={css`display: block;
                      text-align: center;
                      font-family: Inter;
                      font-size: 16px;
                      color: #5E5E5E;
                      max-width: 400px;
                      width: 400px;
                      margin: auto;`}>
                        <div className={css`text-align: left;`}>
                            You have unsubscribed from the notifications mail
                        </div>
                    </div>
                </div>
                <div className={css`background-color: #F0F5F8;
                  color: black;
                  text-align: center;
                  padding: 40px 20px;
                  font-size: 14px;`}>
                    Intuition Robotics, 2345 Yale St., Palo Alto, California 94306, (855) 888-1295
                </div>
            </div>
        </div>
    </>

}
